(function () {
  const acc = document.querySelector('[data-accordion]');
  if (!acc) return;

  const items = Array.from(acc.querySelectorAll('.bvw-item'));

  function setPanelHeight(item, open) {
    const panel = item.querySelector('.bvw-panel');
    if (!panel) return;

    if (open) {
      const content = panel.firstElementChild;
      panel.style.height = 'auto';
      const target = content ? content.offsetHeight : panel.scrollHeight;
      panel.style.height = '0px';
      requestAnimationFrame(() => {
        panel.style.height = target + 'px';
      });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });
    }
  }

  function openItem(item) {
    items.forEach(i => {
      const btn = i.querySelector('.bvw-btn');
      const panel = i.querySelector('.bvw-panel');
      const isTarget = (i === item);
      i.classList.toggle('is-open', isTarget);
      if (btn) btn.setAttribute('aria-expanded', String(isTarget));
      if (panel) setPanelHeight(i, isTarget);
    });
  }

  // Init: open first
  const first = items[0];
  if (first) {
    first.classList.add('is-open');
    const btn = first.querySelector('.bvw-btn');
    const panel = first.querySelector('.bvw-panel');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) {
      panel.style.height = 'auto';
      const content = panel.firstElementChild;
      const target = content ? content.offsetHeight : panel.scrollHeight;
      panel.style.height = target + 'px';
    }
    items.slice(1).forEach(i => {
      const b = i.querySelector('.bvw-btn');
      const p = i.querySelector('.bvw-panel');
      if (b) b.setAttribute('aria-expanded', 'false');
      if (p) p.style.height = '0px';
    });
  }

  acc.addEventListener('click', (e) => {
    const btn = e.target.closest('.bvw-btn');
    if (!btn) return;

    const item = btn.closest('.bvw-item');
    if (!item) return;

    const isOpen = item.classList.contains('is-open');
    if (isOpen) {
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      setPanelHeight(item, false);
    } else {
      openItem(item);
    }
  });

  acc.addEventListener('transitionend', (e) => {
    if (!e.target.classList.contains('bvw-panel')) return;
    const panel = e.target;
    const item = panel.closest('.bvw-item');
    if (item && item.classList.contains('is-open')) {
      panel.style.height = 'auto';
    }
  });

  window.addEventListener('resize', () => {
    const open = acc.querySelector('.bvw-item.is-open .bvw-panel');
    if (open) {
      open.style.height = 'auto';
      const content = open.firstElementChild;
      const target = content ? content.offsetHeight : open.scrollHeight;
      open.style.height = target + 'px';
    }
  }, { passive: true });
})();